import { videoButton } from '../components/light-gallery';
import { imageModal } from '../components/light-gallery';

export default () => {
  'use strict';
  videoButton();
  imageModal();
}
